export const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate)
  const end = new Date(endDate)

  const startDay = start.getDate()
  const endDay = end.getDate()
  const month = start.toLocaleDateString('en-US', { month: 'long' })
  const year = start.getFullYear()

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return 'th'
    switch (day % 10) {
      case 1: return 'st'
      case 2: return 'nd'
      case 3: return 'rd'
      default: return 'th'
    }
  }

  if (startDay === endDay) {
    return `${month} ${startDay}${getOrdinal(startDay)} ${year}`
  }
  return `${month} ${startDay}${getOrdinal(startDay)}-${endDay}${getOrdinal(endDay)} ${year}`
}

export const getEventStatus = (startDate) => {
  const today = new Date()
  const event = new Date(startDate)

  // Set today to start of day for better comparison
  today.setHours(0, 0, 0, 0)

  return event >= today ? 'upcoming' : 'past'
}